let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lbfYP")).then(() => parcelRequire('a3W1U'));